import { ReactChild } from 'react';
import { createGlobalStyle, ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { Theme } from './theme';

interface ThemeProviderProps {
  children: ReactChild;
  theme: Theme;
}

const GlobalStyles = createGlobalStyle`     
  *, *::before, *::after {
    box-sizing: border-box;
    outline: revert;
  }
  
  button[type="button"], button[type="submit"] {
    outline: revert!important;
  }
  
  html {
    font-size: 62.5%;
  }
  
  body {
    font-size: 1.6rem;
    padding: 0;
    margin: 0;   
  }

  button, textarea {
    font-family: inherit;
    margin: 0;
    padding: 0;
  }
`;

export const ThemeProvider = ({ children, theme }: ThemeProviderProps): JSX.Element => (
  <StyledComponentsThemeProvider theme={theme}>
    <>
      <GlobalStyles />
      {children}
    </>
  </StyledComponentsThemeProvider>
);
